import React, { Component } from "react";
import { Modal, Table, Row, Col, Button, Checkbox, message } from 'antd';
import InputForm from "../components/InputForm";
import "./Pages.css";
import axios from 'axios';
import { getUsuario, saveToken, savePermissoes, removeToken, removePermissoes } from "../utils/LoginManager";

const { Column } = Table;

export default class PermissoesPage extends Component {

  state = {
    selectedRowKeys: [], // Verifique aqui para configurar a coluna padrão
    grupoSelect: [],
    listaRegistros: [],
    carregando: false,
    grupo: 0,
  };

  start = () => {
    this.setState({ carregando: true });
    // ajax pedido após o preenchimento vazio
    setTimeout(() => {
      this.setState({
        selectedRowKeys: [],
        carregando: false,
      });
    }, 1000);
  }

  componentDidUpdate(antProps, antState) {

  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });

    this.buscaGrupos();
  }

  buscaGrupos = (value) => {
    this.setState({
      grupoSelect: [],
      carregando: false,
      habilitaBtnGravar: false,
    });
    axios.get('/grupos_usuarios/lista', {
      params: {
        vendedor: 'X'
      }
    }).then(response => {
      const { data } = response;
      const grupoSelect = data.map(regList => {
        return {
          key: regList.gu_idf,
          label: regList.gu_descricao
        }
      });
      this.setState({
        grupoSelect,
      })

    }).catch(error => {
      console.error(error.response);
    })
  }

  onChangeGrupo = event => {
    this.setState({
      grupo: event.target.value,
    });

    this.getListaRegistros(event.target.value.key);
  };


  getListaRegistros = (value) => {
    this.setState({ carregando: true, listaRegistros: [], habilitaBtnGravar: false });

    axios
      .get('/usuarios/listaPermissoes', {
        params: {
          grupo: value,
        }
      })
      .then(response => {
        this.setState({
          listaRegistros: response.data,
          carregando: false,
          habilitaBtnGravar: true,
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };



  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  }

  onChangeConsultar(e, registro) {
    registro.pg_consultar = e.target.checked;
    this.forceUpdate();
  }

  onChangeNovo(e, registro) {
    registro.pg_novo = e.target.checked;
    this.forceUpdate();
  }

  onChangeEditar(e, registro) {
    registro.pg_editar = e.target.checked;
    this.forceUpdate();
  }

  onChangeExcluir(e, registro) {
    registro.pg_excluir = e.target.checked;
    this.forceUpdate();
  }



  renderCheckConsultar = (pg_consultar, registro) => {
    return (
      <Checkbox
        checked={pg_consultar}
        onChange={(event) => this.onChangeConsultar(event, registro)}
      />
    );
  };

  renderCheckNovo = (pg_novo, registro) => {
    return (
      <Checkbox
        checked={pg_novo}
        onChange={(event) => this.onChangeNovo(event, registro)}
      />
    );
  };

  renderCheckEditar = (pg_editar, registro) => {
    return (
      <Checkbox
        checked={pg_editar}
        onChange={(event) => this.onChangeEditar(event, registro)}
      />
    );
  };

  renderCheckExcluir = (pg_excluir, registro) => {
    return (
      <Checkbox
        checked={pg_excluir}
        onChange={(event) => this.onChangeExcluir(event, registro)}
      />
    );
  };


  onGravarConceder = () => {
    const { listaRegistros } = this.state;
    for (let i = 0; i < listaRegistros.length; i++) {
      const registro = listaRegistros[i];
      registro.pg_consultar = true;
      registro.pg_editar = true;
      registro.pg_excluir = true;
      registro.pg_novo = true;
    }
    this.setState({
      listaRegistros
    })
  }

  onGravarRevogar = () => {
    const { listaRegistros } = this.state;
    for (let i = 0; i < listaRegistros.length; i++) {
      const registro = listaRegistros[i];
      registro.pg_consultar = false;
      registro.pg_editar = false;
      registro.pg_excluir = false;
      registro.pg_novo = false;
    }
    this.setState({
      listaRegistros
    })
  }



  onGravarClick = () => {
    const { listaRegistros, usuario, grupo } = this.state;

    this.setState({ carregando: true })

    // console.log('onGravarClick: ', usuario)
    // console.log('onGravarClick: ', grupo)

    axios.put(`/usuarios/updatePermissoes/${grupo.key}`, {
      listaRegistros
    })
      .then(response => {
        if (parseInt(usuario.ue_grupo) !== parseInt(grupo.key)) {
          this.setState({
            carregando: false,
            listaRegistros: [],
            habilitaBtnGravar: false,
            grupo: 0,
          });
          message.success('Permissões gravadas com sucesso.');
        } else {

          const body = {
            usuario: usuario.usu_email,
            senha: 'e807f1fcf8',
            empresa: usuario.emp_codigo,
          };
          axios.post("/usuarios/login", body)
            .then(response => {
              saveToken(response.data.token);
              savePermissoes(response.data.grupo);
              this.setState({
                carregando: false,
                listaRegistros: [],
                habilitaBtnGravar: false,
                grupo: 0,
              });
              message.success('Permissões gravadas com sucesso');
            })
            .catch(error => {
              console.error(error.response);
              this.setState({ salvando: false })
              Modal.error({ title: 'Falha - Atenção!', content: 'Configurações salvas. Feche o sistema e faça ligin novamente. ' + error.response.data, okText: 'OK', })
            });

        }
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
        Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { carregando, grupoSelect, listaRegistros, grupo, habilitaBtnGravar } = this.state;

    // console.log('PermissoesPage.this.state: ', this.state);

    return (

      <Row>
        <div className="contentRoutesContainer">
          <span className="tituloPage">Permissões dos Usuários</span>
          <div className="divider-page" />

          <div className="pageFiltro">
            <div className="avaliacoesPageFiltro">
              <form onSubmit={this.onBuscar}>
                <Row>

                  <Col xs={24} sm={8}>
                    <InputForm
                      type="select"
                      id="grupo"
                      ref="grupo"
                      value={grupo}
                      placeholder="Selecione o Grupo de Usuário"
                      onChange={this.onChangeGrupo}
                      data={grupoSelect}
                      validator={value => Boolean(value)}
                      errorMessage="Informe o Grupo de Usuário"
                      showSearch
                    />
                  </Col>


                  <Col xs={24} sm={3} style={{ marginTop: 4, marginLeft: 10 }}>
                    <Button
                      type="ghost"
                      disabled={!habilitaBtnGravar}
                      onClick={this.onGravarConceder}
                    >
                      Conceder Tudo
                    </Button>
                  </Col>


                  <Col xs={24} sm={3} style={{ marginTop: 4, marginLeft: 10 }}>
                    <Button
                      type="ghost"
                      disabled={!habilitaBtnGravar}
                      onClick={this.onGravarRevogar}
                    >
                      Revogar Tudo
                    </Button>
                  </Col>

                  <Col xs={24} sm={3} style={{ marginTop: 4, marginLeft: 20 }}>
                    <Button
                      type="primary"
                      disabled={!habilitaBtnGravar}
                      onClick={this.onGravarClick}
                      className="botao-primary"
                      style={{width: 150}}
                    >
                      Salvar Permissões
                    </Button>
                  </Col>

                </Row>
              </form>
            </div>

          </div>

          <div>
            <Table
              dataSource={listaRegistros}
              size="middle"
              rowKey={(registro => registro.pp_permissao)}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              pagination={false}
            >
              <Column
                key="pp_descricao"
                dataIndex="pp_descricao"
                title="Descrição das Permissões"
                width={400}
                align="left"
              />

              <Column
                key="pg_consultar"
                dataIndex="pg_consultar"
                title="Consultar"
                render={this.renderCheckConsultar}
                width={90}
                align="center"
              />

              <Column
                key="pg_novo"
                dataIndex="pg_novo"
                title="Novo"
                render={this.renderCheckNovo}
                width={80}
                align="center"
              />
              <Column
                key="pg_editar"
                dataIndex="pg_editar"
                title="Editar"
                render={this.renderCheckEditar}
                width={80}
                align="center"
              />
              <Column
                key="pg_excluir"
                dataIndex="pg_excluir"
                title="Excluir"
                render={this.renderCheckExcluir}
                width={80}
                align="center"
              />

            </Table>
          </div>
        </div>
      </Row>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/PermissoesPage.js